<template>
	<v-data-table
		v-bind="$props"
		:headers="extendedHeaders"
		:items-per-page="itemsPerPage"
		:item-class="extendedItemClass"
		dense
		:disable-sort="disableSort"
		:class="interactable ? 'cassie-table' : 'cassie-table--no-hover'"
		no-data-text="No data available"
		fixed-header
		:height="defaultHeight"
		@current-items="$emit('current-items', $event)"
		v-on="$listeners"
	>
		<template #item.selected-column="{ item: row }">
			<v-icon :color="rowSelected(row) ? 'info' : ''">
				{{ rowSelected(row) ?
					multiSelect ? '$checkboxOn' : 'mdi-radiobox-marked' :
					multiSelect ? '$checkboxOff': 'mdi-radiobox-blank'
				}}
			</v-icon>
		</template>
		<template
			v-for="slot in slots"
			#[slot]="props"
		>
			<slot
				:name="slot"
				v-bind="props"
			/>
		</template>
	</v-data-table>
</template>

<script>
import { VDataTable } from 'vuetify/lib'

export default {
	name: 'data-table',
	extends: VDataTable,
	props: {
		selected: Function,
		multiSelect: {
			type: Boolean,
			default: false
		},
		disableSort: {
			type: Boolean,
			default: false
		},
		itemsPerPage: {
			type: Number,
			default: 15
		},
		height: {
			type: String
		},
		interactable: {
			type: Boolean,
			default: true,
			required: false
		}
	},
	computed: {
		hasRowSelected () {
			return !!this.selected
		},
		slots () {
			return Object.keys(this.$scopedSlots)
		},
		extendedHeaders () {
			if (!this.hasRowSelected) return this.headers
			return [
				{
					width: 35,
					value: 'selected-column',
					align: 'center'
				},
				...this.headers
			]
		},
		defaultHeight () {
			if (this.height) return this.height
			else if (this.$props.items.length >= 15 && !this.height) return '525'
			else return 'auto'
		}
	},
	methods: {
		rowSelected (row) {
			return this.hasRowSelected ? this.selected(row) : false
		},
		extendedItemClass (row) {
			const extendedClass = this.rowSelected(row) ? 'blue lighten-5' : ''
			return this.itemClass ? `${this.itemClass(row)} ${extendedClass}` : extendedClass
		}
	}
}
</script>

<style lang="scss">
.cassie-table.cassie-table {
  tr:hover:not(.v-data-table__expanded__content) {
    cursor: pointer !important;
    background-color: var(--global-main-background-color) !important;
  }
}

.cassie-table.cassie-table > .v-data-table__wrapper > table > thead > tr > th {
	color: var(--global-table-header-text, var(--global-muted-foreground));
	font-family: 'Inter', sans-serif;
	font-size: 0.75rem; // 12px - aligned with NextJS
	font-weight: 500; // Semibold for headers
	background-color: var(--global-table-header-bg, var(--global-syrenis-grey));
	padding: 12px 16px; // Consistent padding for headers

	// Ensure sort icons inherit header text colour for dark mode compatibility
	.v-icon,
	.v-data-table-header__icon {
		color: var(--global-table-header-text, var(--global-muted-foreground));
	}
}

// Prevent Vuetify sortable header styles from overriding font color
.theme--light.v-data-table .v-data-table-header th.sortable:hover,
.theme--light.v-data-table .v-data-table-header th.sortable.active,
.theme--dark.v-data-table .v-data-table-header th.sortable:hover,
.theme--dark.v-data-table .v-data-table-header th.sortable.active {
	color: var(--global-table-header-text, var(--global-muted-foreground)) !important;

	// Prevent sort icon color from being overridden
	.v-icon,
	.v-data-table-header__icon {
		color: var(--global-table-header-text, var(--global-muted-foreground)) !important;
	}
}

// Replace arrow sort icon with chevron
.cassie-table .v-data-table-header__icon {
	// Hide default arrow icon and show chevron instead
	&.mdi-arrow-up::before {
		content: "\F0143"; // mdi-chevron-up
	}
	&.mdi-arrow-down::before {
		content: "\F0140"; // mdi-chevron-down
	}
}
.cassie-table.cassie-table > .v-data-table__wrapper > table > tbody > tr > td {
	color: var(--global-foreground);
	font-family: 'Inter', sans-serif;
	font-size: 0.875rem; // 14px - aligned with NextJS
	font-weight: 500;
	padding: 12px 16px; // Consistent padding for body cells
}

// Pagination and footer styling
.cassie-table.cassie-table .v-data-footer {
	font-family: 'Inter', sans-serif;
	font-size: 0.875rem; // 14px - aligned with NextJS

	.v-data-footer__select,
	.v-data-footer__pagination {
		font-family: 'Inter', sans-serif;
		font-size: 0.875rem;
	}
}

.cassie-table--no-hover {
  tr:hover:not(.v-data-table__expanded__content) {
    background-color: rgba(0, 0, 0, 0) !important;
  }
}
</style>
